import { EntityPointer, EntityPointerSchema, EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export enum InviteInviterType {
    Business = 'business',
    User = 'user',
}

export const InviteInviterSchema = z
    .object({
        type: EnumSchema(InviteInviterType),
        business: EntityPointerSchema.optional(),
        user: z
            .object({
                email: z.string().email(),
            })
            .optional(),
    })
    .strict();

export class InviteInviter extends FromSchema(InviteInviterSchema) {
    type: InviteInviterType;
    business?: EntityPointer;
    user?: {
        email: string;
    };
}
